import lang from 'lang'
import settingsConfig from 'settings/config'
import request from '@/modules/base/util/request'

import { toast } from '@/modules/base/components/toast/toastConfig'

// actions
const SHOW_LOADER = 'settings/deliveryConditions/SHOW_LOADER'
const HIDE_LOADER = 'settings/deliveryConditions/HIDE_LOADER'
const SHOW_MODAL_LOADER = 'settings/deliveryConditions/SHOW_MODAL_LOADER'
const HIDE_MODAL_LOADER = 'settings/deliveryConditions/HIDE_MODAL_LOADER'
const OPEN_FORM_MODAL = 'settings/deliveryConditions/OPEN_FORM_MODAL'
const CLOSE_FORM_MODAL = 'settings/deliveryConditions/CLOSE_FORM_MODAL'
const SET_DELIVERY_CONDITIONS = 'settings/deliveryConditions/SET_DELIVERY_CONDITIONS'
const SET_SELECTED_DELIVERY_CONDITIONS = 'settings/deliveryConditions/SET_SELECTED_DELIVERY_CONDITIONS'
const RESET_DELIVERY_CONDITIONS = 'settings/deliveryConditions/RESET_DELIVERY_CONDITIONS'

// reducer
const initialState = {
  isLoading: false,
  formModalOpen: false,
  isModalLoading: false,
  conditions: [],
  selectedCondition: undefined,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_LOADER:
      return { ...state, isLoading: true }

    case HIDE_LOADER:
      return { ...state, isLoading: false }

    case SHOW_MODAL_LOADER:
      return { ...state, isModalLoading: true }

    case HIDE_MODAL_LOADER:
      return { ...state, isModalLoading: false }

    case OPEN_FORM_MODAL:
      const { selectedCondition } = action
      return { ...state, formModalOpen: true, selectedCondition }

    case CLOSE_FORM_MODAL:
      return { ...state, formModalOpen: false, selectedCondition: undefined }

    case SET_SELECTED_DELIVERY_CONDITIONS: {
      const { selectedCondition } = action
      return { ...state, selectedCondition }
    }

    case RESET_DELIVERY_CONDITIONS: {
      return { ...state, selectedCondition: undefined }
    }

    case SET_DELIVERY_CONDITIONS:
      const { data } = action
      return { ...state, ...data }

    default:
      return state
  }
};

// action creators
const showLoader = () => {
  return {
    type: SHOW_LOADER,
  }
}

const hideLoader = () => {
  return {
    type: HIDE_LOADER,
  }
}

const showModalLoader = () => {
  return {
    type: SHOW_MODAL_LOADER,
  }
}

const hideModalLoader = () => {
  return {
    type: HIDE_MODAL_LOADER,
  }
}

export const openFormModal = (condition) => ({
  type: OPEN_FORM_MODAL,
  selectedCondition: condition,
})

export const closeFormModal = () => ({
  type: CLOSE_FORM_MODAL,
})

export const resetDeliveryConditions = () => ({
  type: RESET_DELIVERY_CONDITIONS,
})

export const setSelectedDeliveryConditions = (condition) => ({
  type: SET_SELECTED_DELIVERY_CONDITIONS,
  selectedCondition: condition,
})

const setDeliveryConditions = (data) => {
  return {
    type: SET_DELIVERY_CONDITIONS,
    data,
  }
}

export const updateDeliveryCondition = (id, data) => {
}

export const fetchDeliveryConditions = () => {
  return (dispatch) => {
    dispatch(showLoader())
    request(settingsConfig.deliveryConditions, { auth: true, method: 'GET', isConcurrent: true })
      .then((response) => {
        const { body: { data: conditions } } = response
        dispatch(setDeliveryConditions({ conditions }))
        dispatch(hideLoader())
      })
      .catch(() => {
        dispatch(hideLoader())
      })
  }
}

export const createCondition = (data) => {
  return (dispatch, getState) => {
    const { settings: { deliveryConditions: { conditions } } } = getState()
    dispatch(showModalLoader())

    const requests = [
      request(`${settingsConfig.deliveryConditions}`, { auth: true, method: 'POST', data }),
    ]

    // set isDefault false if other condition is new default
    const currentDefaultCondition = conditions.find(condition => condition.isDefault)
    if (data.isDefault && currentDefaultCondition) {
      currentDefaultCondition.isDefault = false
      requests.push(request(`${settingsConfig.deliveryConditions}/${currentDefaultCondition.id}`, { auth: true, method: 'PUT', data: { isDefault: false } }))
    }

    return Promise.all(requests)
      .then(([createConditionResponse]) => {
        const { id } = createConditionResponse.body.data
        const createdCondition = { ...data, id }

        dispatch(setDeliveryConditions({ conditions: [...conditions, createdCondition] }))
        dispatch(closeFormModal())
        dispatch(setSelectedDeliveryConditions(createdCondition))
        toast.showToast({ message: lang.deliveryConditionCreateSuccessMessage })
        return createdCondition
      })
      .catch(() => {
        toast.showToast({ type: 'error', message: lang.defaultErrorMessage })
      })
      .finally(() => dispatch(hideModalLoader()))
  }
}

export const updateCondition = (id, data) => {
  return (dispatch, getState) => {
    dispatch(showModalLoader())
    const { settings: { deliveryConditions: { conditions } } } = getState()

    const requests = [
      request(`${settingsConfig.deliveryConditions}/${id}`, { auth: true, method: 'PUT', data }),
    ]

    // set isDefault false if other condition is new default
    const currentDefaultCondition = conditions.find(condition => condition.isDefault)
    if (data.isDefault && currentDefaultCondition.id !== id) {
      currentDefaultCondition.isDefault = false
      requests.push(request(`${settingsConfig.deliveryConditions}/${currentDefaultCondition.id}`, { auth: true, method: 'PUT', data: { isDefault: false } }))
    }

    return Promise.all(requests)
      .then(() => {
        const updatedConditions = conditions.map(condition => {
          if (currentDefaultCondition && !currentDefaultCondition.isDefault && currentDefaultCondition.id === condition.id) {
            return { ...condition, isDefault: false }
          }

          return condition.id === id ? { ...condition, ...data } : condition
        })

        const updatedCondition = updatedConditions.find(condition => condition.id === id)
        dispatch(setDeliveryConditions({ conditions: updatedConditions }))
        dispatch(closeFormModal())
        toast.showToast({ message: lang.deliveryConditionSaveSuccessMessage })
        return updatedCondition
      })
      .catch(() => {
        toast.showToast({ message: lang.defaultErrorMessage, type: 'error' })
      })
      .finally(() => dispatch(hideModalLoader()))
  }
}

export const deleteCondition = (id) => {
  return (dispatch, getState) => {
    request(`${settingsConfig.deliveryConditions}/${id}`, { method: 'DELETE', auth: true })
      .then(() => {
        const { settings: { deliveryConditions: { conditions } } } = getState()
        const filteredConditions = conditions.filter(condition => condition.id !== id)

        dispatch(setDeliveryConditions({ conditions: filteredConditions }))
        toast.showToast({ message: lang.deliveryConditionDeleteSuccessMessage })
      })
      .catch(() => {
        toast.showToast({ type: 'error', message: lang.deliveryConditionDeleteErrorMessage })
      })
  }
}
